/**
 * Сахар над `useAuthStore()` для шаблонов.
 *
 * Существует ради одной строчки — `storeToRefs`. Прямое `const { user } =
 * useAuthStore()` молча ломает реактивность (деструктуризация снимает `.value`
 * и связь со стором теряется), и это самая частая ошибка в Pinia. Здесь она
 * сделана один раз и правильно, а вьюхи пишут `const { isAdmin } = useAuth()`.
 *
 * Стор при этом отдаётся наружу как `store` — действия (`login`, `logout`)
 * зовут через него: `storeToRefs` функции не оборачивает, и раскладывать их по
 * отдельным полям значило бы держать два списка вместо одного.
 *
 * ⚠️ ЗДЕСЬ ТОЛЬКО СИСТЕМНАЯ РОЛЬ. `isAdmin` отвечает на вопрос «это
 * супер-администратор системы» и годится для экранов «Пользователи» и кнопки
 * «Создать мероприятие». Для всего, что происходит **внутри** мероприятия,
 * есть `useEventAccess()` — там ответ зависит от состава конкретного
 * соревнования, а не от учётной записи.
 */
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'

export function useAuth() {
  const store = useAuthStore()

  const {
    user,
    role,
    isAdmin,
    isAuthenticated,
    displayName,
    initials,
  } = storeToRefs(store)

  return {
    user,
    role,
    isAdmin,
    isAuthenticated,
    displayName,
    initials,
    store,
  }
}
